import { useRef } from 'react'
import textServices from 'services/text-services'
import useMediaQuery from 'hooks/use-media-query'
import { credencialesImage } from '../constants'
import { useFloatingDecor, useScrollParallax } from '../hooks/use-scroll-parallax'

// "1873" history block (Figma desktop 5631:1594 + 5631:1595, mobile
// 5867:3920): brewery photo window with a scroll parallax over a beige
// text block. Decorative hop/wheat (5631:1602, 5631:1897, 5867:4193) float.
const HistorySection = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const sectionRef = useRef<HTMLElement>(null)
  const windowRef = useRef<HTMLDivElement>(null)
  const imageRef = useRef<HTMLImageElement>(null)

  // Desktop: the 1923x568 photo is taller than its 461px window, so the
  // surplus scrolls from -surplus to 0. Mobile has no surplus: the image is
  // scaled 1.25 and travels the same proportional range around center.
  const surplus = () => {
    const image = imageRef.current
    const frame = windowRef.current
    if (!image || !frame) return 0
    return isDesktop ? Math.max(image.offsetHeight - frame.offsetHeight, 0) : frame.offsetHeight * 0.25
  }
  useScrollParallax(
    sectionRef,
    imageRef,
    {
      from: () => (isDesktop ? -surplus() : -surplus() / 2),
      to: () => (isDesktop ? 0 : surplus() / 2),
      scale: isDesktop ? 1 : 1.25
    },
    [isDesktop]
  )
  useFloatingDecor(sectionRef, isDesktop)

  return (
    <section ref={sectionRef} className="credenciales__history">
      <div ref={windowRef} className="credenciales__history-window">
        <img
          ref={imageRef}
          className="credenciales__history-photo"
          src={credencialesImage(isDesktop ? 'DESKTOP' : 'MOBILE', isDesktop ? 'img_cerveceria_desk_2x' : 'img_cerveceria_mob_2x')}
          alt="Cervecería Heineken, 1873"
        />
      </div>
      <div className="credenciales__history-block">
        <p className="credenciales__history-year">
          {textServices.findByText('credenciales/history/year', '1873')}
        </p>
        <p className="credenciales__history-text">
          {textServices.findByText(
            'credenciales/history/text',
            'Desde entonces, nuestros maestros cerveceros han perfeccionado el arte de crear una cerveza auténtica.'
          )}
        </p>
      </div>
      {isDesktop && (
        <span
          className="credenciales__history-float credenciales__history-float--wheat"
          data-float="wheat"
          aria-hidden="true"
        >
          <img src={credencialesImage('DESKTOP', 'flotante_trigo_desk_2_2x')} alt="" loading="lazy" draggable={false} />
        </span>
      )}
      <span
        className="credenciales__history-float credenciales__history-float--hop"
        data-float="hop"
        aria-hidden="true"
      >
        <img src={credencialesImage(isDesktop ? 'DESKTOP' : 'MOBILE', isDesktop ? 'flotante_lupulo_desk_2_2x' : 'flotante_lupulo_mob_2_2x')} alt="" loading="lazy" draggable={false} />
      </span>
    </section>
  )
}

export default HistorySection
